import type { PropsWithChildren } from 'react'
import { SiteNavigation } from '@/components/navigation/SiteNavigation'
import { PortfolioFooter } from './PortfolioFooter'
import { useNavigationPathname } from '@/hooks/useNavigationPathname'

export const SiteShell = ({ children }: PropsWithChildren) => {
  const pathname = useNavigationPathname()
  return <div className="site-shell bg-[var(--background)] text-[var(--foreground)]">
    <SiteNavigation />
    <main className="site-main">{children}</main>
    <PortfolioFooter className={pathname === '/' ? 'portfolio-footer-main' : ''} />
  </div>
}
